export function AssistantAdminDashboard() {
  return (
    <>
      <p>
        This is the ASSISTANT admin Dashboard..... Will include assitant admin
        access and same options as employees and users and employees,{" "}
      </p>
    </>
  );
}
